import { get } from '../httpClient';

/**
 * Free creators' monthly attendee-hours (server/api-util/attendeeUsage.js).
 */
export const attendeeUsageAPI = {
  mine: () => get('/api/creator/attendee-usage'),
};
